export const ENVIO_ENDPOINT = 'https://gnosis-e702590.dedicated.hyperindex.xyz/v1/graphql';
export const ENVIO_WS_ENDPOINT = 'wss://gnosis-e702590.dedicated.hyperindex.xyz/v1/graphql';
export const ENVIO_API_TOKEN = 'a50c149a-ff7f-4a60-a3a9-a5830332407e';
